import { render, staticRenderFns } from "./ProspectCards.vue?vue&type=template&id=63e63e5a&"
import script from "./ProspectCards.vue?vue&type=script&lang=js&"
export * from "./ProspectCards.vue?vue&type=script&lang=js&"
import style0 from "./ProspectCards.vue?vue&type=style&index=0&id=63e63e5a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports